import { render, staticRenderFns } from "./ActivationEmailSent.vue?vue&type=template&id=e7881276&scoped=true&"
import script from "./ActivationEmailSent.vue?vue&type=script&lang=js&"
export * from "./ActivationEmailSent.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/simplePage.css?vue&type=style&index=0&id=e7881276&prod&scoped=true&lang=css&"
import style1 from "./ActivationEmailSent.vue?vue&type=style&index=1&id=e7881276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7881276",
  null
  
)

export default component.exports